import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { GiftCardAreaCard } from './components';
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../components/ErrorHandling/ErrorHandling';
import { actionGetGiftCardDisplayAreas, actionResetGiftCardDisplayAreas } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionResetPaymentTransaction } from 'actions';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(5)
    }
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}));

const GiftCardsAreasList = (props) => {

  const constredirect = (area) => {

    if (area) {
      props.history.push({
        pathname: 'giftcards/' + area.DisplayAreaNo
      })
    }
  }

  const dispatch = useDispatch()

  useEffect(() => {
    actionGetGiftCardDisplayAreas(dispatch);
  }, []);


  const classes = useStyles();
  const giftcardAreaNumbers = useSelector(state => state.reducerGiftCardDisplayAreas);
  const error = useSelector(state => state.reducerDisplayAreas.displayAreasError);
  const giftcards = useSelector(state => state.reducerGiftCards);
  const events = useSelector(state => state.reducerShopCart.events);
  const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
  const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
  const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
  const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

  useEffect(() => {
    if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
      giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
      actionResetPaymentTransaction(dispatch);
    }
  }, []);

  useEffect(() => {

    if (giftcardAreaNumbers.loading == true) {
      actionStartAppLoader(dispatch);
    }
    else {
      actionEndAppLoader(dispatch);
    }
  })

  const errorcancelhandle = () => {
    actionResetGiftCardDisplayAreas(dispatch);
  }

  if (giftcardAreaNumbers.giftcardsdisplayAreas === undefined) {
    return <div>
      <ErrorHandling msg={error} open={error.length > 0 ? true : false}
        handleclose={errorcancelhandle} />
    </div>
  }

  return (

    <div id="vt_page_giftcard_display_area" className={classes.root}>

      <div className={classes.content}>
        <Grid
          container
          spacing={2}
          style={{ paddingTop: window.matchMedia("(max-width: 500px)").matches ? 35 : 5 }}
        >
          {giftcardAreaNumbers.giftcardsdisplayAreas.map((area, i) => {
            return area.ShowOnline && area !== undefined ?
              <Grid
                item
                key={area.DisplayAreaNo}
                lg={4}
                md={6}
                xs={12}
              >
                <GiftCardAreaCard area={area} callCalender={constredirect} />
              </Grid>

              : null
          })}

        </Grid>
      </div>
    </div>
  );
};

export default GiftCardsAreasList;
